"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AutosizeColumns", {
  enumerable: true,
  get: function get() {
    return _Container.AutosizeColumns;
  }
});
Object.defineProperty(exports, "CellValue", {
  enumerable: true,
  get: function get() {
    return _Cell.CellValue;
  }
});
exports.DataGridContainer = exports.DataGrid = void 0;
Object.defineProperty(exports, "DefaultSizeColumns", {
  enumerable: true,
  get: function get() {
    return _Container.DefaultSizeColumns;
  }
});
Object.defineProperty(exports, "Difference", {
  enumerable: true,
  get: function get() {
    return _Cell.Difference;
  }
});
Object.defineProperty(exports, "FullScreenToggler", {
  enumerable: true,
  get: function get() {
    return _Container.FullScreenToggler;
  }
});
Object.defineProperty(exports, "GgCell", {
  enumerable: true,
  get: function get() {
    return _Cell["default"];
  }
});
Object.defineProperty(exports, "GridActionsCellItem", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.GridActionsCellItem;
  }
});
Object.defineProperty(exports, "LicenseInfo", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.LicenseInfo;
  }
});
Object.defineProperty(exports, "PresentedRows", {
  enumerable: true,
  get: function get() {
    return _components.PresentedRows;
  }
});
Object.defineProperty(exports, "SelectableToolbar", {
  enumerable: true,
  get: function get() {
    return _Toolbar.SelectableToolbar;
  }
});
Object.defineProperty(exports, "ValueWrapper", {
  enumerable: true,
  get: function get() {
    return _Cell.ValueWrapper;
  }
});
exports.dataCy = void 0;
Object.defineProperty(exports, "dataCyHeaderCell", {
  enumerable: true,
  get: function get() {
    return _useColumns2.dataCyHeaderCell;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getDataGridUtilityClass", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.getDataGridUtilityClass;
  }
});
Object.defineProperty(exports, "gridFilteredDescendantCountLookupSelector", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.gridFilteredDescendantCountLookupSelector;
  }
});
Object.defineProperty(exports, "useDeclaredColumns", {
  enumerable: true,
  get: function get() {
    return _useDeclaredColumns.useDeclaredColumns;
  }
});
Object.defineProperty(exports, "useGridApiContext", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.useGridApiContext;
  }
});
Object.defineProperty(exports, "useGridApiRef", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.useGridApiRef;
  }
});
Object.defineProperty(exports, "useGridRootProps", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.useGridRootProps;
  }
});
Object.defineProperty(exports, "useGridSelector", {
  enumerable: true,
  get: function get() {
    return _xDataGridPro.useGridSelector;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _components = require("./components");
var _Highlighting = _interopRequireDefault(require("./components/Highlighting"));
var _hooks = require("./hooks");
var _Checkbox = _interopRequireDefault(require("./components/Checkbox"));
var _Tooltip = _interopRequireDefault(require("@gogame/ui/Tooltip"));
var _utils = require("@gogame/ui/utils");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _getScaleColorIndex = require("./utils/getScaleColorIndex");
var _GridErrorBoundary = require("./GridErrorBoundary");
var _useGridStyles = require("./useGridStyles");
var _aggregation = require("./aggregation");
var _ColumnsWidthContext = _interopRequireDefault(require("./components/Container/ColumnsWidthContext"));
var _DeclaredColumnsProvider = _interopRequireDefault(require("./components/DeclaredColumns/DeclaredColumnsProvider"));
var _usePinnedColumns = require("./hooks/usePinnedColumns");
var _jsxRuntime = require("react/jsx-runtime");
var _useDeclaredColumns = require("./components/DeclaredColumns/useDeclaredColumns");
var _useColumns2 = require("./hooks/useColumns");
var _Toolbar = require("./components/Toolbar");
var _Container = require("./components/Container");
var _Cell = _interopRequireWildcard(require("./components/Cell"));
var _excluded = ["IconComponent"],
  _excluded2 = ["rows", "children", "getTreeDataPath", "treeData", "apiRef", "getRowId", "hasChildrenOnServer", "pinnedRows", "columnsState", "tableSettings", "withColorScale", "notInitedLabel", "count", "loading", "fetching", "checkboxSelection", "allPageSelection", "isRowSelectable", "toolbar", "selectedRowsToolbarActions", "onReorder", "onCollapse", "onChangeSettings", "minHeight", "lazyLoad", "rowHeight", "columnHeaderHeight", "coloredRow", "colorGetter", "onChangeColorScalesColumns", "disableColumnResize", "storageKey", "title", "defaultColumnWidth", "actions", "presentedRows", "onClearPresentedRows", "classes", "onTogglePercentage", "decorationModel", "ready", "filtered", "fullScreen", "onToggleFullScreen", "detailPanelExpandedRowIds", "hideGroupingColumn", "sortingTooltip", "treeDataWithGaps", "visibleColumns", "onPinnedColumnsChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'DataGrid';
var DataGridContainer = exports.DataGridContainer = _components.Container;
var VIRTUALIZATION_LIMIT = 500;
var EMPTY_ARR = [];
var EMPTY_OBJ = {};

// test

var SortedIcon = function SortedIcon(_ref) {
  var IconComponent = _ref.IconComponent,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useGridRootProps = (0, _xDataGridPro.useGridRootProps)(),
    sortingTooltip = _useGridRootProps.sortingTooltip;
  var icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, _objectSpread({}, props));
  return sortingTooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
    title: sortingTooltip,
    children: icon
  }) : icon;
};
function renderSortedIcon(IconComponent) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SortedIcon, _objectSpread(_objectSpread({}, props), {}, {
      IconComponent: IconComponent
    }));
  };
}
var slots = {
  baseCheckbox: _Checkbox["default"],
  toolbar: _components.DataGridToolbar,
  cell: _components.CellWrapper,
  columnMenu: _components.ColumnMenu,
  pagination: _components.Pagination,
  loadingOverlay: _components.LoadingOverlay,
  noRowsOverlay: _components.NoResults,
  noResultsOverlay: _components.NoResults,
  footer: _components.Footer,
  presentedRowsFilter: _components.PresentedRows,
  columnSortedAscendingIcon: renderSortedIcon(_xDataGridPro.GridArrowUpwardIcon),
  columnSortedDescendingIcon: renderSortedIcon(_xDataGridPro.GridArrowDownwardIcon)
};
var sortingOrder = ['desc', 'asc'];
var localText = {
  checkboxSelectionSelectAllRows: 'Select Current Page',
  checkboxSelectionUnselectAllRows: 'Unselect Current Page'
};
var getDiff = function getDiff() {
  var oldProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(newProps).reduce(function (diff, k) {
    var oldVal = oldProps[k];
    var newVal = newProps[k];
    if (oldVal !== newVal) {
      return _objectSpread(_objectSpread({}, diff), {}, _defineProperty({}, k, {
        oldVal: oldVal,
        newVal: newVal
      }));
    }
    return diff;
  }, {});
};
var MomoGrid = /*#__PURE__*/_react["default"].memo(_xDataGridPro.DataGridPro, function arePropsEqual(oldProps, newProps) {
  var diff = getDiff(oldProps, newProps);
  return Object.keys(diff).length === 0;
});
function useStateLessStore(key) {
  var getState = function getState() {
    return JSON.parse(localStorage.getItem(key) || 'null') || {};
  };
  var _useState = (0, _react.useState)(function () {
      return 0;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    changeCounter = _useState2[0],
    setChangeCounter = _useState2[1];
  var increaseChangeCounter = function increaseChangeCounter() {
    return setChangeCounter(function (c) {
      return c + 1;
    });
  };
  var empty = (0, _react.useMemo)(function () {
    return localStorage.getItem(key) === null;
  }, [changeCounter]);
  (0, _react.useEffect)(function () {
    increaseChangeCounter();
  }, [key]);
  return {
    setFieldValue: function setFieldValue(field, value) {
      var newState = _objectSpread(_objectSpread({}, getState()), {}, _defineProperty({}, field, value));
      localStorage.setItem(key, JSON.stringify(newState));
      increaseChangeCounter();
    },
    getFieldValue: function getFieldValue(field) {
      return getState()[field];
    },
    empty: empty,
    clear: function clear() {
      localStorage.removeItem(key);
      increaseChangeCounter();
    }
  };
}
var DataGrid = exports.DataGrid = function DataGrid(props) {
  var _props$rows = props.rows,
    _unsafeRows = _props$rows === void 0 ? EMPTY_ARR : _props$rows,
    _props$children = props.children,
    children = _props$children === void 0 ? EMPTY_ARR : _props$children,
    getTreeDataPath = props.getTreeDataPath,
    _props$treeData = props.treeData,
    treeData = _props$treeData === void 0 ? false : _props$treeData,
    apiRef = props.apiRef,
    _props$getRowId = props.getRowId,
    getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
    hasChildrenOnServer = props.hasChildrenOnServer,
    _props$pinnedRows = props.pinnedRows,
    pinnedRows = _props$pinnedRows === void 0 ? EMPTY_ARR : _props$pinnedRows,
    _props$columnsState = props.columnsState,
    columnsState = _props$columnsState === void 0 ? EMPTY_OBJ : _props$columnsState,
    _props$tableSettings = props.tableSettings,
    tableSettings = _props$tableSettings === void 0 ? EMPTY_OBJ : _props$tableSettings,
    _props$withColorScale = props.withColorScale,
    withColorScale = _props$withColorScale === void 0 ? false : _props$withColorScale,
    _props$notInitedLabel = props.notInitedLabel,
    notInitedLabel = _props$notInitedLabel === void 0 ? 'Please choose one of your Presets or use the filters in order to get data.' : _props$notInitedLabel,
    _props$count = props.count,
    count = _props$count === void 0 ? 0 : _props$count,
    loading = props.loading,
    fetching = props.fetching,
    checkboxSelection = props.checkboxSelection,
    allPageSelection = props.allPageSelection,
    isRowSelectable = props.isRowSelectable,
    toolbar = props.toolbar,
    selectedRowsToolbarActions = props.selectedRowsToolbarActions,
    onReorder = props.onReorder,
    onCollapse = props.onCollapse,
    onChangeSettings = props.onChangeSettings,
    minHeight = props.minHeight,
    lazyLoad = props.lazyLoad,
    _props$rowHeight = props.rowHeight,
    rowHeight = _props$rowHeight === void 0 ? 48 : _props$rowHeight,
    _props$columnHeaderHe = props.columnHeaderHeight,
    columnHeaderHeight = _props$columnHeaderHe === void 0 ? 48 : _props$columnHeaderHe,
    coloredRow = props.coloredRow,
    colorGetter = props.colorGetter,
    onChangeColorScalesColumns = props.onChangeColorScalesColumns,
    disableColumnResize = props.disableColumnResize,
    storageKey = props.storageKey,
    title = props.title,
    _props$defaultColumnW = props.defaultColumnWidth,
    defaultColumnWidth = _props$defaultColumnW === void 0 ? 160 : _props$defaultColumnW,
    actions = props.actions,
    presentedRows = props.presentedRows,
    onClearPresentedRows = props.onClearPresentedRows,
    _props$classes = props.classes,
    propsClasses = _props$classes === void 0 ? {} : _props$classes,
    onTogglePercentage = props.onTogglePercentage,
    decorationModel = props.decorationModel,
    ready = props.ready,
    filtered = props.filtered,
    fullScreen = props.fullScreen,
    onToggleFullScreen = props.onToggleFullScreen,
    detailPanelExpandedRowIds = props.detailPanelExpandedRowIds,
    hideGroupingColumn = props.hideGroupingColumn,
    sortingTooltip = props.sortingTooltip,
    treeDataWithGaps = props.treeDataWithGaps,
    _props$visibleColumns = props.visibleColumns,
    visibleColumns = _props$visibleColumns === void 0 ? EMPTY_ARR : _props$visibleColumns,
    onPinnedColumnsChange = props.onPinnedColumnsChange,
    other = _objectWithoutProperties(props, _excluded2);

  // useLogPropsChanges(props);
  var internalApiRef = (0, _react.useRef)();
  var handleRef = (0, _utils.useForkRef)(internalApiRef, apiRef);
  var columns = (0, _hooks.useColumnsFromChildren)(children);
  var classes = (0, _useGridStyles.useGridStyles)({
    allPageSelection: allPageSelection
  });
  var rows = (0, _react.useMemo)(function () {
    if (treeData && _unsafeRows) {
      var s = new Set(_toConsumableArray(_unsafeRows.map(function (r) {
        return getTreeDataPath(r).join('///');
      })));
      return _unsafeRows.filter(function (row) {
        var path = getTreeDataPath(row);
        return path.length === 1 ||
        // root
        s.has(path.slice(0, -1).join('///'));
      });
    }
    return _unsafeRows;
  }, [treeData, _unsafeRows, getTreeDataPath]);
  var aggregationModel = (0, _react.useMemo)(function () {
    var _columnsState$scaled;
    var __aggregationRules = {};
    columnsState === null || columnsState === void 0 || (_columnsState$scaled = columnsState.scaled) === null || _columnsState$scaled === void 0 || _columnsState$scaled.forEach(function (field) {
      __aggregationRules[field] = 'extremum';
    });
    return __aggregationRules;
  }, [columnsState === null || columnsState === void 0 ? void 0 : columnsState.scaled]);
  (0, _aggregation.useGridAggregation)({
    apiRef: internalApiRef,
    aggregationModel: aggregationModel
  });
  var _useStateLessStore = useStateLessStore(storageKey),
    storeEmpty = _useStateLessStore.empty,
    setColumnWidthStorage = _useStateLessStore.setFieldValue,
    getColumnWidthStorage = _useStateLessStore.getFieldValue,
    clearColumnsWidthStorage = _useStateLessStore.clear;
  var valueGetter = (0, _react.useCallback)(function (value, row, column, apiRef) {
    var field = column.field;
    if (isAutoGeneratedRowNull(apiRef === null || apiRef === void 0 ? void 0 : apiRef.current, row)) {
      return value;
    } else {
      return decorationModel !== null && decorationModel !== void 0 && decorationModel[field] && value !== undefined ? decorationModel[field]({
        value: value,
        row: row,
        column: column,
        api: apiRef.current
      }) : value;
    }
  }, [decorationModel]);
  var valueFormatter = (0, _react.useCallback)(function (value, row, column, apiRef) {
    var _column$getValue = column.getValue,
      getValue = _column$getValue === void 0 ? function (v) {
        return v;
      } : _column$getValue,
      getValueColor = column.getValueColor,
      getPercentValue = column.getPercentValue,
      getCompareValue = column.getCompareValue,
      getCompareValueColor = column.getCompareValueColor,
      getComparePercentValue = column.getComparePercentValue,
      getDifferenceValue = column.getDifferenceValue,
      getIcon = column.getIcon,
      getCompareIcon = column.getCompareIcon,
      getTooltip = column.getTooltip,
      _column$formatter = column.formatter,
      formatter = _column$formatter === void 0 ? function (v) {
        return v;
      } : _column$formatter;
    if (isAutoGeneratedRowNull(apiRef === null || apiRef === void 0 ? void 0 : apiRef.current, row)) {
      return {};
    } else {
      var v = getValue === null || getValue === void 0 ? void 0 : getValue(value, row, column);
      var compareV = getCompareValue === null || getCompareValue === void 0 ? void 0 : getCompareValue(value, row, column);
      return {
        value: formatter(v, row, column, apiRef),
        valueColor: getValueColor === null || getValueColor === void 0 ? void 0 : getValueColor(value),
        percentValue: getPercentValue === null || getPercentValue === void 0 ? void 0 : getPercentValue(value),
        compareValue: compareV !== undefined ? formatter(compareV, row, column, apiRef) : compareV,
        comparePercentValue: getComparePercentValue === null || getComparePercentValue === void 0 ? void 0 : getComparePercentValue(value),
        compareValueColor: getCompareValueColor === null || getCompareValueColor === void 0 ? void 0 : getCompareValueColor(value),
        difference: getDifferenceValue === null || getDifferenceValue === void 0 ? void 0 : getDifferenceValue(value),
        icon: getIcon === null || getIcon === void 0 ? void 0 : getIcon(value, row, column),
        compareIcon: getCompareIcon === null || getCompareIcon === void 0 ? void 0 : getCompareIcon(value),
        tooltip: getTooltip === null || getTooltip === void 0 ? void 0 : getTooltip(v, row),
        compareTooltip: getTooltip === null || getTooltip === void 0 ? void 0 : getTooltip(compareV, row)
      };
    }
  }, []);
  var order = (0, _react.useMemo)(function () {
    var _columnsState$order;
    // remove actions from ordered columns
    return columnsState === null || columnsState === void 0 || (_columnsState$order = columnsState.order) === null || _columnsState$order === void 0 ? void 0 : _columnsState$order.filter(function (col) {
      return col !== 'actions';
    });
  }, [columnsState === null || columnsState === void 0 ? void 0 : columnsState.order]);
  var _useColumns = (0, _hooks.useColumns)({
      columns: columns,
      order: order,
      collapsed: columnsState.collapsed,
      percentage: columnsState.percentage,
      scaled: columnsState.scaled,
      checkboxSelection: checkboxSelection,
      coloredRow: coloredRow,
      colorGetter: colorGetter,
      disabledPaddingClassName: classes.disabledPadding,
      defaultColumnWidth: defaultColumnWidth,
      getColumnWidthStorage: getColumnWidthStorage,
      valueGetter: valueGetter,
      valueFormatter: valueFormatter,
      allPageSelection: allPageSelection
    }),
    columnsToRender = _useColumns.columnsToRender,
    groupingColDef = _useColumns.groupingColDef;
  var pinnedColumns = (0, _usePinnedColumns.usePinnedColumns)({
    columnsToRender: columnsToRender,
    coloredRow: coloredRow,
    checkboxSelection: checkboxSelection,
    statePinnedLeft: columnsState.pinned
  });
  console.log('pinnedColumns', pinnedColumns, columnsToRender);
  var handlePinnedColumnsChange = function handlePinnedColumnsChange(pinned, params) {
    console.log('handlePinnedColumnsChange', pinnedColumns, pinned, params);
    var pinnedLeft = pinned.left.map(function (col) {
      switch (col) {
        case _xDataGridPro.GRID_CHECKBOX_SELECTION_COL_DEF.field:
          return null;
        case _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD:
          return groupingColDef.field;
        default:
          return col;
      }
    }).filter(function (col) {
      return col !== null;
    });
    onPinnedColumnsChange === null || onPinnedColumnsChange === void 0 || onPinnedColumnsChange(pinnedLeft, params);
  };
  // useMemo(() => {
  //   console.log('columnsToRender', columnsToRender,internalApiRef?.current,  internalApiRef?.current?.getAllColumns())
  //
  // }, [columnsToRender]);

  var handleColumnResize = (0, _react.useCallback)(function (_ref2) {
    var field = _ref2.colDef.field,
      width = _ref2.width;
    setColumnWidthStorage(field, width);
  }, [setColumnWidthStorage]);
  var collapse = (0, _hooks.useCollapse)({
    collapsed: columnsState.collapsed,
    onCollapse: onCollapse
  });
  var handleColumnHeaderClick = (0, _react.useCallback)(function (col, event) {
    var _columnsState$collaps;
    var isCollapsed = columnsState === null || columnsState === void 0 || (_columnsState$collaps = columnsState.collapsed) === null || _columnsState$collaps === void 0 ? void 0 : _columnsState$collaps.includes(col.field);
    event.stopPropagation();
    if (isCollapsed) {
      collapse(col);
    }
  }, [collapse, columnsState === null || columnsState === void 0 ? void 0 : columnsState.collapsed]);
  var handleReorder = (0, _hooks.useReorder)({
    order: order,
    onReorder: onReorder
  });
  var handleChangePagination = (0, _react.useCallback)(function (pagination) {
    onChangeSettings === null || onChangeSettings === void 0 || onChangeSettings(pagination);
  }, [onChangeSettings]);
  var changeSettingsRef = (0, _react.useRef)();
  changeSettingsRef.current = onChangeSettings;
  var groupingColDefField = groupingColDef === null || groupingColDef === void 0 ? void 0 : groupingColDef.field;
  var handleSortModelChange = (0, _react.useCallback)(function (models) {
    if (models[0]) {
      var _changeSettingsRef$cu;
      var _models$ = models[0],
        sort = _models$.sort,
        field = _models$.field;
      (_changeSettingsRef$cu = changeSettingsRef.current) === null || _changeSettingsRef$cu === void 0 || _changeSettingsRef$cu.call(changeSettingsRef, {
        orderDir: sort,
        orderBy: field === _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD ? groupingColDefField : field
      });
    }
  }, [groupingColDefField]);
  var handleIsCellEditable = (0, _react.useCallback)(function () {
    return false;
  }, []);
  var _sortModel = (0, _react.useMemo)(function () {
    var sortField = tableSettings.orderBy && tableSettings.orderBy === (groupingColDef === null || groupingColDef === void 0 ? void 0 : groupingColDef.field) ? _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD : tableSettings.orderBy;
    var fields = [_xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD].concat(_toConsumableArray(columnsToRender.map(function (_ref3) {
      var field = _ref3.field;
      return field;
    })));
    if (fields.includes(sortField)) {
      return [{
        field: sortField,
        sort: tableSettings.orderDir
      }];
    }
  }, [tableSettings, columnsToRender, groupingColDef === null || groupingColDef === void 0 ? void 0 : groupingColDef.field]);
  var sortModel = (0, _react.useMemo)(function () {
    return _sortModel;
  }, [JSON.stringify(_sortModel)]);
  (0, _react.useEffect)(function () {
    if (treeData) {
      var _internalApiRef$curre;
      (_internalApiRef$curre = internalApiRef.current) === null || _internalApiRef$curre === void 0 || _internalApiRef$curre.setRows(rows);
    }
  }, [treeData, rows, internalApiRef.current]);
  var gridLoading = loading || fetching;
  var columnVisibilityModel = (0, _react.useMemo)(function () {
    var allColumns = columns.map(function (_ref4) {
      var field = _ref4.field;
      return field;
    });
    var initial = _defineProperty(_defineProperty({}, _xDataGridPro.GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field, false), _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD, !hideGroupingColumn);
    if (visibleColumns !== null && visibleColumns !== void 0 && visibleColumns.length) {
      return allColumns.reduce(function (acc, col) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, col, visibleColumns.includes(col)));
      }, initial);
    }
    if (order) {
      return order.reduce(function (acc, col) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, col, allColumns.includes(col)));
      }, initial);
    }
    return _objectSpread(_objectSpread({}, initial), allColumns.reduce(function (acc, col) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, col, true));
    }, initial));
  }, [columns, order, hideGroupingColumn, visibleColumns]);
  var pinnedRowsConfig = {
    top: rows.length ? pinnedRows : EMPTY_ARR
  };
  var memorizedPinnedRowsConfig = (0, _react.useMemo)(function () {
    return pinnedRowsConfig;
  }, [JSON.stringify(pinnedRowsConfig)]);
  var gridClasses = (0, _react.useMemo)(function () {
    return _objectSpread({
      root: classes.root,
      virtualScroller: (0, _clsx4["default"])(_defineProperty({}, classes.virtualScroller, !loading || loading && fetching)),
      toolbarContainer: classes.toolbarContainer,
      footerContainer: classes.footerContainer,
      columnHeader: classes.columnHeader,
      pinnedRows: (0, _clsx4["default"])(classes.pinnedRows, {
        // [classes.pinnedRowsFetching]: fetching,
      }),
      main: (0, _clsx4["default"])(classes.main, _defineProperty(_defineProperty({}, classes.mainFetching, fetching), classes.mainInitial, !rows.length)),
      scrollbar: (0, _clsx4["default"])(_defineProperty({}, classes.displayNone, !rows.length)),
      'pinnedColumnHeaders--right': classes.pinnedColumnHeaders,
      'scrollbar--horizontal': classes.scrollbarHorizontal,
      menu: classes.menu,
      cell: classes.cell,
      overlayWrapper: (0, _clsx4["default"])(classes.overlayWrapper),
      overlayWrapperInner: classes.overlayWrapperInner
    }, propsClasses);
  }, [classes, loading, fetching, rows.length, propsClasses]);
  var memorizedGridClasses = (0, _react.useMemo)(function () {
    return gridClasses;
  }, [JSON.stringify(gridClasses)]);
  var hideFooterPagination = !rows.length;

  // const _r = useRef({});
  //
  // useEffect(() => {
  //   return internalApiRef.current?.subscribeEvent('stateChange', function (state, ...o) {
  //     console.group('stateChange');
  //
  //     Object.keys(state).forEach((k) => {
  //       if (_r.current[k] !== undefined && state[k] !== _r.current[k]) {
  //         console.log(k, state[k], _r.current[k]);
  //       }
  //     });
  //     console.groupEnd('stateChange');
  //     _r.current = state;
  //   });
  // }, []);

  var handleGetCellClassName = (0, _react.useCallback)(function (_ref5) {
    var _api$getRow, _api$state$aggregatio, _colDef$getValue;
    var value = _ref5.value,
      field = _ref5.field,
      id = _ref5.id,
      colDef = _ref5.colDef,
      api = _ref5.api,
      row = _ref5.row,
      rowNode = _ref5.rowNode;
    if (!(colDef !== null && colDef !== void 0 && colDef.isColorScale)) {
      return '';
    }
    if (api !== null && api !== void 0 && (_api$getRow = api.getRow(id)) !== null && _api$getRow !== void 0 && _api$getRow.isTotalValue) {
      return '';
    }
    var extremum = (_api$state$aggregatio = api.state.aggregation) === null || _api$state$aggregatio === void 0 || (_api$state$aggregatio = _api$state$aggregatio.lookup) === null || _api$state$aggregatio === void 0 || (_api$state$aggregatio = _api$state$aggregatio[rowNode.parent]) === null || _api$state$aggregatio === void 0 ? void 0 : _api$state$aggregatio[field];
    var colorScaleValue = (_colDef$getValue = colDef.getValue) === null || _colDef$getValue === void 0 ? void 0 : _colDef$getValue.call(colDef, value, row, colDef); // TODO: add getColorScaleWeight() = v =>v.value

    if (extremum && Number.isFinite(colorScaleValue)) {
      var rulName = "colorScale-".concat((0, _getScaleColorIndex.getScaleColorIndex)({
        minValue: extremum.min,
        maxValue: extremum.max,
        value: colorScaleValue,
        reversed: colDef === null || colDef === void 0 ? void 0 : colDef.isHighlightLower
      }));
      return rulName;
    }
  }, [classes]);
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    _detailPanelExpandedRowIds = _useState4[0],
    _setDetailPanelExpandedRowIds = _useState4[1];
  (0, _react.useEffect)(function () {
    _setDetailPanelExpandedRowIds(detailPanelExpandedRowIds);
  }, [detailPanelExpandedRowIds, rows]);
  var allCells = (0, _react.useMemo)(function () {
    return tableSettings.limit * columnsToRender.length;
  }, [tableSettings.limit, columnsToRender.length]);

  // useLogPropsChanges(props);

  (0, _react.useEffect)(function () {
    console.log('count ? columnHeaderHeight : 0', {
      resolvedColumnHeaderHeight: count ? columnHeaderHeight : 0,
      columnHeaderHeight: columnHeaderHeight,
      count: count
    });
  }, [count, columnHeaderHeight]);
  var disableVirtualization = !treeData && allCells <= VIRTUALIZATION_LIMIT;
  console.log('storeEmpty', storeEmpty);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GridErrorBoundary.GridErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Container, {
      minHeight: minHeight,
      hasRows: rows.length > 0,
      fullScreen: fullScreen,
      onToggle: onToggleFullScreen,
      withColorScale: withColorScale,
      component: _Highlighting["default"],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColumnsWidthContext["default"].Provider, {
        value: {
          canResetColumnsWidth: !storeEmpty,
          clearColumnsWidthStorage: clearColumnsWidthStorage
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeclaredColumnsProvider["default"], {
          columns: columns,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MomoGrid, _objectSpread({
            onPinnedColumnsChange: handlePinnedColumnsChange,
            treeDataWithGaps: treeDataWithGaps,
            disableVirtualization: disableVirtualization
            // row selection
            ,

            isRowSelectable: isRowSelectable,
            checkboxSelection: checkboxSelection,
            indeterminateCheckboxAction: 'select'
            // disable start
            // selection
            ,
            "data-cy-role": 'grid',
            disableRowSelectionOnClick: true
            // sorting
            ,
            disableMultipleColumnsSorting: true
            // resize
            ,
            disableColumnResize: disableColumnResize
            //filtering
            ,
            disableColumnFilter: true,
            disableChildrenFiltering: true,
            disableMultipleColumnsFiltering: true
            // disable end

            // borders start
            ,
            showColumnVerticalBorder: true,
            showCellVerticalBorder: true
            // borders end
            ,

            "data-cy": dataCy,
            columnVisibilityModel: columnVisibilityModel,
            pinnedRows: memorizedPinnedRowsConfig,
            rows: rows,
            rowCount: count,
            rowHeight: rowHeight,
            columns: columnsToRender,
            classes: memorizedGridClasses,
            pinnedColumns: pinnedColumns // can cause blank rows on scroll
            ,
            getTreeDataPath: getTreeDataPath,
            treeData: treeData,
            groupingColDef: groupingColDef,
            apiRef: handleRef,
            getRowId: getRowId,
            hasChildrenOnServer: hasChildrenOnServer,
            onColumnOrderChange: handleReorder,
            onColumnWidthChange: handleColumnResize,
            sortingOrder: sortingOrder,
            isCellEditable: handleIsCellEditable,
            getCellClassName: withColorScale ? handleGetCellClassName : undefined,
            localeText: localText,
            slotProps: {
              baseCheckbox: {
                allPageSelection: allPageSelection
              },
              toolbar: {
                toolbar: toolbar,
                selectedRowsToolbarActions: selectedRowsToolbarActions,
                title: title,
                actions: actions,
                count: count
              },
              columnMenu: {
                onCollapse: collapse,
                onApplyColorScale: onChangeColorScalesColumns,
                onTogglePercentage: onTogglePercentage
              },
              pagination: {
                limit: tableSettings.limit,
                offset: tableSettings.offset,
                count: count,
                onChange: handleChangePagination
              },
              loadingOverlay: {
                fetching: fetching,
                key: "fetching_".concat(fetching)
              },
              noRowsOverlay: {
                notInitedLabel: notInitedLabel,
                inited: ready,
                filtered: !gridLoading && filtered
              },
              noResultsOverlay: {
                notInitedLabel: notInitedLabel,
                inited: ready,
                filtered: !gridLoading && filtered
              },
              presentedRowsFilter: {
                presentedRows: presentedRows,
                onClearPresentedRows: onClearPresentedRows
              }
            },
            slots: slots,
            sortingTooltip: sortingTooltip,
            columnBufferPx: 100,
            rowBufferPx: 100,
            loading: gridLoading,
            onColumnHeaderClick: handleColumnHeaderClick,
            sortModel: sortModel,
            hideFooterPagination: hideFooterPagination,
            hideFooter: hideFooterPagination && !(presentedRows !== null && presentedRows !== void 0 && presentedRows.length),
            pagination: true,
            paginationMode: 'server',
            sortingMode: 'server',
            onSortModelChange: handleSortModelChange,
            detailPanelExpandedRowIds: _detailPanelExpandedRowIds,
            columnHeaderHeight: count ? columnHeaderHeight : 0
          }, other))
        })
      })
    })
  });
};
function defaultGetRowId(_ref6) {
  var id = _ref6.id;
  return id;
}
function isAutoGeneratedRowNull(api, row) {
  var rowId = "".concat(api.getRowId(row));
  return rowId.includes('generated-row-null');
}
DataGrid.Column = function () {
  return null;
};
var _default = exports["default"] = DataGrid;